<div class="search-form-wrapper">
  <div id="tour-2" class="search">
    <seds-search class="search-form-input" label="Pesquise um usuário por logon"
      (search)="searchUser($event, false)">
    </seds-search>
  </div>
</div>

<span
  class="clear"
  (click)="searchUser('', true)"
  [ngStyle]="{'opacity': searchValue ? 1 : 0, 'visibility': searchValue ? null : 'hidden'}">
  <mat-icon fontSet="material-icons">chevron_left</mat-icon>
  Listar todos os usuários
</span>
